import { MutationTree } from 'vuex';
import { AuthState } from './types';
import authApi from '@/services/auth';
import billingApi from '@/services/billing';
import accountsApi from '@/services/accounts';
import historyApi from '@/services/history';
import reportingApi from '@/services/reporting';
import licensingApi from '@/services/licensing';
import calibrationApi from '@/services/calibration';
import { event } from 'vue-analytics';
import { load, save } from '@/helpers/storage';

const mutations: MutationTree<AuthState> = {
  setState(state: AuthState, val: any) {
    if (typeof val === 'object' && val.val) {
      state.state = val.val + (val.err ? ' ' + val.err : '');
    } else {
      state.state = String(val);
    }
  },
  clearState(state: AuthState) {
    state.state = null;
  },

  setToken(state: AuthState, token) {
    authApi.setToken(token);
    billingApi.setToken(token);
    accountsApi.setToken(token);
    historyApi.setToken(token);
    reportingApi.setToken(token);
    licensingApi.setToken(token);
    calibrationApi.setToken(token);

    state.token = token;
    save('token', token);

    // session timeout
    const split = String(token).split('.');
    if (split.length > 2) {
      const ob = JSON.parse(atob(split[1]));
      state.sessionTimeoutUnix = ob.exp;
    }
  },
  logout(state: AuthState) {
    event('auth-store', 'logout');

    state.account = null;
    save('token', null);

    state.token = null;
    save('account', null);
  },
};

export default mutations;
